<template>
    <div class="modal is-active"  >
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">เลือก Bact</p>
                <button class="delete" aria-label="close"   @click="closeBtn" ></button>
            </header>
            <section class="modal-card-body">

                <b-input v-model="searchName"></b-input>
<!--                :paginated=true-->
<!--                :per-page="perPage"-->
<!--                :current-page.sync="currentPage"-->
                <b-table
                        :data="filterMstBactDat"
                        :bordered=false
                        :striped=false
                        narrowed
                        :hoverable=false
                        :focusable=false
                        mobile-cards>
                    <b-table-column   label="No."  v-slot="props"  >
                        {{props.index +1 }}
                    </b-table-column>
                    <b-table-column   label="Name"  v-slot="props"  >
                        <text-highlight :queries="queries">{{ props.row.name }}</text-highlight>
                    </b-table-column>
                    <b-table-column   label="#"  v-slot="props"  >
                        <b-button type="is-success" size="is-medium" outlined icon-left="check"   @click="pickupBact(props.row.id)">
                           เลือก
                        </b-button>
                    </b-table-column>
                </b-table>

            </section>
            <footer class="modal-card-foot">
                <!--                <button class="button"   @click="closeBtn" >Cancel</button>-->
                <b-button type="is-danger"  @click="closeBtn">Cancel</b-button>

            </footer>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";


    export default {
        name: "SelectBact",
        computed:{
            ...mapState({
                mstOrgaDat: state => state.orga.mstOrgaDat,

            }),

            filterMstBactDat: function () {

               const tmp = this.mstOrgaDat.filter((BactDat)=>{
                    // console.log(listOfUser.id_auth_group)
                    return BactDat.name.toUpperCase().indexOf(this.searchName.toUpperCase()) > -1
                })

                // if(this.searchName !== ''){
                //     // tmp are array
                //     tmp.forEach(dat=>{
                //         // console.log(this.searchName)
                //         // dat.name.toString().replace(this.searchName,`<b>${this.searchName}</b>`)
                //         dat.name = dat.name.toString().replace(this.searchName,`<b>${this.searchName}</b>`)
                //         // dat.name.replace(this.searchName,`test`)
                //         console.log(JSON.stringify(dat))
                //     })
                // }
                return tmp
            },
            queries(){
                return this.searchName.split(" ");
            }
        },
        methods:{
            closeBtn(){
               this.$emit('closeSelectBact')
            },
            pickupBact(_id){
                 // console.log(_id)
                this.$emit('closeSelectBactWithPickData',{id : _id})
            }
        },
        data(){
            return{
                searchName : '',
                // currentPage : 1,
                // perPage : 10,

            }
        }
    }
</script>

<style scoped>

</style>